var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"flex items-center justify-center hamburger",attrs:{"aria-label":"Menu openen"},on:{"click":_vm.handleClick}},[_c('q-icon',{staticClass:"w-7 h-7",attrs:{"name":_vm.iconName}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }